var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ConfirmButtons,{staticClass:"bc-edit-action-buttons",attrs:{"ok-label":_vm.$t('buttons.save'),"disabled":_setup.isSaving,"disabled-ok":_setup.isSaving || _vm.disabled,"button-width":"140px"},on:{"ok":_setup.save,"cancel":_setup.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }